module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo6.cbcb820c.png";